import React from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { AppBar, Toolbar, makeStyles, Box, Link } from "@material-ui/core";
import Logo from "src/components/Logo";
import LinearProgress from "@material-ui/core/LinearProgress";
import WcagButtons from "src/components/layout/WcagButtons";

const useStyles = makeStyles((theme) => ({
  root: {},
  toolbar: {
    height: 64,
  },
  loader: {
    color: theme.palette.primary,
    marginBottom: theme.spacing(0.2),
  },
  logolink: theme.hiContrast
    ? {
        "&:focus": {
          borderBottom: "2px solid #000000",
        },
      }
    : {
        "&:focus": {
          borderBottom: "2px solid #FFFFFF",
        },
      },
}));

const TopBar = ({ className, loaderOn, systemInfo, ...rest }) => {
  const classes = useStyles();

  return (
    <div>
      <AppBar className={clsx(classes.root, className)} elevation={0} {...rest}>
        <Toolbar className={classes.toolbar}>
          <Link
            component={RouterLink}
            variant="h6"
            to={`/`}
            className={classes.logolink}
          >
            <Logo systemInfo={systemInfo} />
          </Link>
          <Box flexGrow={1} />
          <WcagButtons></WcagButtons>
        </Toolbar>
        {loaderOn ? <LinearProgress className={classes.loader} /> : <></>}
      </AppBar>
    </div>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
};

export default TopBar;
